// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header[data-v-3cc24629]{margin:5rem 0}.header__container[data-v-3cc24629]{max-width:49.375rem}@media only screen and (min-width:960px){.header__container[data-v-3cc24629]{padding:0!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
